import styled from 'styled-components';

export const OpenButton = styled.button`
  background-color: transparent;
  font-size: inherit;
  font-family: inherit;

  &:focus-visible {
    border-radius: 4px;
    outline: 3px solid black;
    outline-offset: 1px;
  }
`;
